// extracted by mini-css-extract-plugin
export default {"links":"t50XaW","links__link":"OaWorH"};